var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuarantee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492 492",
    style: {
      enableBackground: "new 0 0 492 492"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "M375.7,260.6c-57.9,0-106.2,43.8-113.6,99.5h-2.2l-33.4-38.6c-4.5-5.2-10.4-7.4-17.1-7.4h-8.9 v-57.2c0-41.6,12.6-108.4,31.9-143.3c5.9-11.1,9.7-23.8,9.7-37.1C242,34.2,207.9,0,165.6,0C121,0.7,88.3,37.9,89.1,78 c0,14.1,4.5,27.5,11.9,38.6c20.8,32.7,29.7,101.7,29.7,141.1v55.7h-8.9c-6.7,0-12.6,3-17.1,7.4l-33.4,38.6H23 c-12.6,0-23,10.4-23,23v63.1c0,4.5,3,7.4,7.4,7.4H291c20.8,23,50.5,37.1,83.9,37.1c63.8,0,115.1-51.2,115.1-115.1 S438.8,260.6,375.7,260.6z M113.6,109.1c-5.9-9.7-8.9-20-9.7-31.2c-0.7-32.7,25.2-62.4,61.6-63.1c34.2,0,61.6,27.5,61.6,61.6 c0,10.4-3,20.8-7.4,29.7c-20.8,36.4-34.2,106.9-34.2,150v18.6h-40.1v-17.1C145.5,219.8,136.6,146.3,113.6,109.1z M185.6,289.5 v23.8h-40.1v-23.8H185.6z M115.8,330.4c1.5-1.5,3.7-2.2,5.2-2.2c19.3,0,69,0,88.3,0c2.2,0,4.5,0.7,5.2,2.2l25.2,29H91.3 L115.8,330.4z M14.8,437.3v-54.9c0-4.5,3.7-8.2,8.2-8.2c10.4,0,199,0,238.3,0c0,23,6.7,44.5,18.6,63.1H14.8z M375.7,475.2 c-54.9,0-99.5-44.5-99.5-100.2s44.5-100.2,99.5-100.2s99.5,45.3,99.5,100.2S430.6,475.2,375.7,475.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M416.3,322.9l-60.8,88.8l-24.1-31.3c-2.2-3.3-6.9-3.8-10.2-1.6c-3.3,2.2-3.8,6.9-1.6,10.2 l30.3,39.1c1.2,2,3.7,3,6,3.3s4.4-0.9,6.1-3.6l66.7-96.9c2.3-3.5,1.4-7.9-2.2-10.2C423.1,319.1,418.6,319.3,416.3,322.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st0",
    d: "M195.3,69.8c0-16.3-13.4-29.7-29.7-29.7s-29.7,13.4-29.7,29.7c0,16.3,13.4,29.7,29.7,29.7 S195.3,86.1,195.3,69.8z M150.7,69.8c0-8.2,6.7-14.8,14.8-14.8s14.8,6.7,14.8,14.8c0,8.2-6.7,14.8-14.8,14.8S150.7,78,150.7,69.8z "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-388-111"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantee);
export default __webpack_public_path__ + "static/media/Guarantee.514bf0d9.svg";
export { ForwardRef as ReactComponent };